"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const formatSSN = (str) => {
    if ((0, lodash_1.isEmpty)(str))
        return str;
    return str?.slice(0, 3) + '-' + str?.slice(3, 5) + '-' + str?.slice(5, 9);
};
exports.default = formatSSN;
